import React, { useRef, useState } from 'react';
import { AccountClosureContext as Context } from './accountClosureContext';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/authContext';
import { createLifecycleRecoveryStore } from './lifecycleRecoveryStore';
import { createLifecycleRecoveryClient } from './lifecycleRecoveryClient';
import { createLifecycleRecoveryTransport } from './lifecycleRecoveryTransport';
const { resolveApiUrl } = require('../../config/apiOrigin');

// Only the server's single DELETE owner selects the production contract.
export function AccountClosureProvider({ children, apiOrigin }) {
  const auth = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState('unavailable');
  const [status, setStatus] = useState('ready');
  const client = useRef(null);
  const authRef = useRef(auth);
  authRef.current = auth;
  const origin = new URL(apiOrigin || resolveApiUrl(process.env)).origin;
  const refresh = async () => {
    let next = 'unavailable';
    try {
      const response = await fetch(`${origin}/api/users/account-closure/contract`, {
        credentials: 'omit', cache: 'no-store', redirect: 'error', referrerPolicy: 'no-referrer',
      });
      const data = await response.json();
      if (response.ok && ['legacy', 'lifecycle'].includes(data?.mode)) next = data.mode;
    } catch (_) { /* No fallback to destructive legacy behavior on uncertainty. */ }
    setMode(next);
    return next;
  };
  const getClient = () => {
    if (!client.current) client.current = createLifecycleRecoveryClient({
      store: createLifecycleRecoveryStore(),
      transport: createLifecycleRecoveryTransport({ baseUrl: origin,
        getInitiationAuthorization: () => authRef.current.user?.token ? `Bearer ${authRef.current.user.token}` : null }),
      clearOrdinaryAuth: async ({ status: nextStatus }) => {
        // Public recovery is outside Profile/Terms/auth gates. The client and IDB
        // survive their unmount; only a validated server projection reaches here.
        setStatus(nextStatus);
        navigate('/account-closure', { replace: true });
        authRef.current.logout();
      },
    });
    return client.current;
  };
  return <Context.Provider value={{ mode, refresh, getClient, status }}>{children}</Context.Provider>;
}
